import "./PropertyThumbnail.css";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";

function PropertyThumbnail(props) {
  let imageDefault;
  let images = props.data.images;
  if (images !== undefined) {
    imageDefault = images.filter((image) => image.default)[0];
  }
  return (
    <div className="col-lg-3 col-md-6 col-sm-12 col-12">
      <div className="block block--style-3">
        <div className="block-image relative">
          <div className="view view-first">
            {imageDefault === undefined || imageDefault == null ? (
              <img
                key={props.data.code}
                className="img-fluid"
                src={"/default_property_image.png"}
                alt={"no_image"}
                style={{ minHeight: "259px", minWidth: "259px" }}
              />
            ) : (
              <img
                key={props.data.code}
                className="img-fluid"
                src={imageDefault.thumbUrl}
                alt={imageDefault.name}
                style={{ minHeight: "259px", minWidth: "259px" }}
              />
            )}
          </div>
          <span className="block-ribbon block-ribbon-fixed block-ribbon-right bg-yellow">
            {props.data.rentValue > 0 ? "Arriendo" : "Venta"}
          </span>
        </div>

        <div className="aux-info-wrapper b-xs-bottom">
          <ul className="aux-info">
            <li className="heading strong-400 text-center">
              <i className="icon-real-estate-017"></i>{" "}
              {props.data.area == null ? "N/A" : props.data.area}
            </li>
            <li className="heading strong-400 text-center">
              <i className="icon-hotel-restaurant-022"></i>{" "}
              {props.data.rooms_count}
            </li>
            <li className="heading strong-400 text-center">
              <i className="icon-hotel-restaurant-158"></i>{" "}
              {props.data.bathrooms_count}
            </li>
            <li className="heading strong-400 text-center">
              <i className="icon-hotel-restaurant-098"></i>{" "}
              {props.data.parking_slots_count}
            </li>
          </ul>
        </div>

        <div className="block-body">
          <h3 className="heading heading-sm">
            <Nav.Link
              as={Link}
              to={{
                pathname: "/propiedad/" + props.data.code,
                state: { property: props.data },
              }}
            >
              {props.data.address}
            </Nav.Link>
          </h3>
          <h4>
            <p>{props.data.property_type_name}</p>
          </h4>
          <p className="description"></p>
        </div>
        <div className="block-footer b-xs-top py-3">
          <div className="row flex flex-items-xs-middle">
            <div className="col col-xs-7">
              <span className="block-price">{props.data.property_price}</span>
              <span className="block-price-text"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PropertyThumbnail;
